// extracted by mini-css-extract-plugin
export default {"item_img_container":"CategoryImg_item_img_container__Q2l3n"};